<script lang="ts">
  import { autosuggestLabels } from "../lang";
  import type { FormOption } from "../types";
  import { startsWith } from "../utils/string";
  import Input from "./Input.svelte";

  export let label: string;
  export let options: FormOption<unknown>[];
  export let value: unknown = null;
  export let limit = 30;

  let search = "";
  let disabled = false;
  let listRef: HTMLUListElement;

  // Watch `value` for changes and clear search if it is empty.
  $: if (!value) {
    clearSearch();
  }

  $: filteredOptions = options
    .filter((option) => startsWith(option.label, search))
    .slice(0, limit);

  // Watch `filteredOptions` for changes and scroll list to top.
  // eslint-disable-next-line no-unused-expressions
  $: filteredOptions && listRef?.scrollTo({ top: 0, behavior: "smooth" });

  // Don’t show list if an item is selected, nothing has been searched,
  // or the autosuggest list is empty.
  $: showList = !disabled && search.length > 0 && filteredOptions.length > 0;

  $: hasOverflow = filteredOptions.length === limit;

  function updateValue(option: FormOption<unknown>) {
    value = option.value;
    search = option.label;
    disabled = true;
  }

  function clearSearch() {
    search = "";
    disabled = false;
  }
</script>

<Input {label} bind:value={search} {disabled} on:clear clearable />

{#if showList}
  <ul class="Autosuggest-list" bind:this={listRef}>
    {#each filteredOptions as option}
      <li class="Autosuggest-item">
        <button class="Autosuggest-button" on:click={() => updateValue(option)}>
          {option.label}
        </button>
      </li>
    {/each}
    {#if hasOverflow}
      <li class="Autosuggest-item">
        <span class="Autosuggest-text">{autosuggestLabels.shortened}</span>
      </li>
    {/if}
  </ul>
{/if}

<style>
  .Autosuggest-list {
    border: var(--size-1) solid var(--color-gray-border);
    border-radius: var(--size-20);
    margin-block-start: var(--size-8);
    max-block-size: 18.5rem;
    overflow-y: auto;
  }

  .Autosuggest-button,
  .Autosuggest-text {
    display: block;
    font-size: var(--size-13);
    padding-block: var(--size-4);
    padding-inline: var(--size-18);
  }

  .Autosuggest-button {
    inline-size: 100%;
    text-align: start;
  }

  .Autosuggest-button:hover {
    background: var(--color-gray-background);
  }

  .Autosuggest-text {
    color: var(--color-gray-dark);
  }
</style>
